import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { Flex as FlexBase } from '@h2/components/layout/flex'

const Flex = styled(FlexBase)`
  display: ${({ useControls }) => (useControls ? 'flex' : 'none')};
  width: 100%;
  margin-top: auto;
  justify-content: space-between;

  @media (${features.minWidth.laptop}) {
    display: flex;
  }
`
const Controls = ({ children, useControls = false }) => {
  return <Flex useControls={useControls}>{children}</Flex>
}

Controls.propTypes = {
  /** Whether the controls should still be rendered in mobile devices. */
  useControls: PropTypes.bool
}

export { Controls }
